import { getAuthData } from "../features/auth/session.js";
import "./collectionCardStats.css";
// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import { IconX } from "../components/icons.jsx";
import { postJson } from "../api/client.jsx";
import * as React from "react";
import { fetchCollectionSummary } from "../api/collection.jsx";
import { fetchCollectionUniverses } from "../api/collection.jsx";
import { fetchCollectionPage } from "../api/collection.jsx";
import * as jsxRuntime from "react/jsx-runtime";
import { IconSearch } from "../components/icons.jsx";
export const hb = (u, o, m) => postJson("/api/vabank/card-preferences/set", {
  initData: u,
  cardId: o,
  enabled: m
});
export const mb = {
  Basic: "🐣",
  Advanced: "🧿",
  Elite: "🦑",
  Majestic: "🔥",
  Absolute: "🐉",
  LIMITED: "🪬",
  Mystic: "💀"
};
export const _n = u => mb[u] ?? "✦";
export const pb = [{
  id: "all",
  label: "Все карты",
  icon: "✦"
}, {
  id: "Basic",
  label: "Basic",
  icon: _n("Basic")
}, {
  id: "Advanced",
  label: "Advanced",
  icon: _n("Advanced")
}, {
  id: "Elite",
  label: "Elite",
  icon: _n("Elite")
}, {
  id: "Majestic",
  label: "Majestic",
  icon: _n("Majestic")
}, {
  id: "Absolute",
  label: "Absolute",
  icon: _n("Absolute")
}];
export const vb = u => {
  const o = u.parentElement?.querySelector("video");
  if (!o) return;
  o.muted = !1, o.volume = 1, o.play().catch(() => {});
  const m = o;
  if (typeof m.webkitEnterFullscreen == "function") {
    m.webkitEnterFullscreen();
    return;
  }
  o.requestFullscreen?.().catch(() => {});
};
export const bb = 6e4;
export const gb = (u, o, m, r) => {
  try {
    return `metacard:collection:v11:${JSON.parse(new URLSearchParams(u).get("user") || "{}").id || "guest"}:${o || "default"}:${r}:${m}`;
  } catch {
    return `metacard:collection:v11:guest:${o || "default"}:${r}:${m}`;
  }
};
export const yb = u => {
  try {
    const o = JSON.parse(sessionStorage.getItem(u) || "");
    return o.data && o.savedAt && Date.now() - o.savedAt < bb ? o.data : null;
  } catch {
    return null;
  }
};
export function CollectionPage({
  meta: u
}) {
  const [o, m] = React.useState(""),
    [r, g] = React.useState("all"),
    [j, B] = React.useState(null),
    [U, N] = React.useState(!1),
    [y, X] = React.useState(null),
    [M, R] = React.useState(null),
    [H, Y] = React.useState(null),
    [P, W] = React.useState(!1),
    [ee, ie] = React.useState([]),
    [w, I] = React.useState(!1),
    [ne, oe] = React.useState(null),
    [T, D] = React.useState(!0),
    [le, te] = React.useState(!1),
    [Z, V] = React.useState(40),
    [ae, Te] = React.useState(""),
    je = React.useRef(0),
    k = React.useRef(null),
    O = y?.owned ?? u.collectionOwned ?? 0,
    L = y?.total ?? u.collectionTotal ?? 0,
    se = o.trim().toLocaleLowerCase("ru-RU"),
    C = r === "all" ? "" : r,
    f = async () => {
      k.current?.abort();
      const K = new AbortController();
      k.current = K;
      const re = ++je.current,
        S = getAuthData();
      if (!S) {
        D(!1), Te("Откройте коллекцию внутри Telegram.");
        return;
      }
      const xe = gb(S, j, se, C),
        ve = yb(xe);
      if (ve) {
        X(ve), D(!1), Te("");
        return;
      }
      D(!0);
      let we = !1;
      try {
        const ye = fetchCollectionSummary(S, j, K.signal),
          Bt = fetchCollectionUniverses(S, K.signal),
          He = await fetchCollectionPage(S, j, 10, !1, !1, se, C, null, K.signal);
        if (re !== je.current) return;
        const Le = {
          ...He,
          owned: y?.owned ?? He.owned,
          total: y?.total ?? He.total,
          rarityStats: y?.rarityStats ?? He.rarityStats,
          universes: y?.universes ?? He.universes
        };
        X(Le), we = !0, D(!1), ye.then(ge => {
          re === je.current && X(gt => gt && {
            ...gt,
            universe: ge.universe,
            owned: ge.owned,
            total: ge.total,
            rarityStats: ge.rarityStats
          });
        }).catch(() => {}), Bt.then(ge => {
          re === je.current && X(gt => gt && {
            ...gt,
            universes: ge.universes
          });
        }).catch(() => {}), Promise.all([ye, Bt]).then(([ge, gt]) => {
          re === je.current && sessionStorage.setItem(xe, JSON.stringify({
            savedAt: Date.now(),
            data: {
              ...Le,
              universe: ge.universe,
              owned: ge.owned,
              total: ge.total,
              rarityStats: ge.rarityStats,
              universes: gt.universes
            }
          }));
        }).catch(() => {}), Te("");
      } catch {
        if (we || re !== je.current) return;
        Te("Не удалось загрузить коллекцию. Попробуйте ещё раз.");
      } finally {
        re === je.current && D(!1);
      }
    };
  React.useEffect(() => {
    const K = window.setTimeout(() => {
      f();
    }, o ? 250 : 0);
    return () => {
      window.clearTimeout(K), je.current += 1, k.current?.abort();
    };
  }, [j, o, r]), React.useEffect(() => {
    V(40);
  }, [o, r, j]), React.useEffect(() => {
    if (Y(null), !M || M.mediaType !== "video") return;
    const K = getAuthData();
    !K || !y?.universe || fetch("/api/collection/card-video", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        initData: K,
        cardId: M.id,
        universe: y.universe
      })
    }).then(async re => re.ok ? re.json() : null).then(re => Y(re?.videoPath || null)).catch(() => Y(null));
  }, [M, y?.universe]);
  const h = async (K = !1) => {
      const re = y,
        S = getAuthData();
      if (!re?.nextCursor || !S || le) return;
      const xe = K ? window.scrollY : null;
      te(!0);
      try {
        const ve = await fetchCollectionPage(S, j, 40, !1, !1, se, C, re.nextCursor);
        X(we => we && we.nextCursor?.id === re.nextCursor?.id ? {
          ...we,
          cards: [...we.cards, ...ve.cards],
          nextOffset: null,
          nextCursor: ve.nextCursor
        } : we), xe !== null && requestAnimationFrame(() => window.scrollTo(0, xe));
      } finally {
        te(!1);
      }
    },
    p = (y?.cards ?? []).filter(K => (r === "all" || K.rarity === r) && (!se || K.name.toLocaleLowerCase("ru-RU").includes(se))),
    G = p.slice(0, Z),
    F = G.length < p.length || y?.nextCursor !== null,
    ce = M?.mediaType === "video",
    ue = y?.universe === "LIMITED" || y?.universe === "Mystic",
    Me = y?.universeName || u.universe || "Вселенная",
    Re = () => {
      if (N(!0), y?.universes.length) return;
      const K = getAuthData();
      K && fetchCollectionUniverses(K).then(re => {
        X(S => S && {
          ...S,
          universes: re.universes
        });
      }).catch(() => {});
    },
    wt = K => {
      X(re => re && {
        ...re,
        universe: K.key,
        universeName: K.name,
        owned: 0,
        total: K.total,
        rarityStats: {},
        cards: [],
        nextOffset: null,
        nextCursor: null
      }), R(null), D(!0), B(K.key), g("all"), m(""), N(!1);
    },
    me = async K => {
      const re = getAuthData();
      if (!(!re || K.locked || ne !== null)) {
        oe(K.id);
        try {
          const S = await hb(re, K.id, !K.enabled);
          ie(xe => xe.map(ve => ve.id === S.card.id ? {
            ...ve,
            enabled: S.card.enabled
          } : ve));
        } finally {
          oe(null);
        }
      }
    };
  return jsxRuntime.jsxs("div", {
    className: "mc-collection",
    children: [jsxRuntime.jsx("header", {
      className: "mc-collection-heading",
      children: jsxRuntime.jsx("div", {
        className: "mc-collection-overview",
        children: jsxRuntime.jsxs("button", {
          className: "mc-collection-universe",
          type: "button",
          onClick: Re,
          "aria-label": "Выбрать вселенную",
          children: [jsxRuntime.jsx("span", {
            className: "mc-collection-universe-name",
            children: Me
          }), !ue && jsxRuntime.jsxs("strong", {
            className: "mc-collection-count",
            children: [O, "/", L]
          })]
        })
      })
    }), jsxRuntime.jsxs("label", {
      className: "mc-collection-search",
      children: [jsxRuntime.jsx(IconSearch, {}), jsxRuntime.jsx("input", {
        value: o,
        onChange: K => m(K.target.value),
        placeholder: "Поиск по картам",
        "aria-label": "Поиск по картам"
      })]
    }), !ue && jsxRuntime.jsx("div", {
      className: "mc-collection-filter-strip",
      "aria-label": "Фильтр по редкости",
      children: pb.filter(K => K.id !== "all").map(K => {
        const re = y?.rarityStats?.[K.id] || {
          owned: 0,
          total: 0
        };
        return jsxRuntime.jsxs("button", {
          type: "button",
          "data-rarity": K.id.toLowerCase(),
          className: r === K.id ? "active" : "",
          onClick: () => g(r === K.id ? "all" : K.id),
          "aria-label": `${K.label}: ${re.owned} из ${re.total}`,
          children: [jsxRuntime.jsx("i", {
            children: K.icon
          }), jsxRuntime.jsx("b", {
            children: re.owned
          })]
        }, K.id);
      })
    }), T ? jsxRuntime.jsx("div", {
      className: "mc-collection-empty",
      children: "Загружаем коллекцию…"
    }) : ae ? jsxRuntime.jsx("div", {
      className: "mc-collection-empty",
      children: ae
    }) : G.length > 0 ? jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [jsxRuntime.jsx("div", {
        className: "mc-collection-grid",
        children: G.map(K => jsxRuntime.jsxs("article", {
          className: `mc-collection-card ${K.mediaType === "video" ? "video" : ""} ${K.rarity.toLowerCase()} ${K.owned ? "owned" : "missing"}`,
          role: "button",
          tabIndex: 0,
          onClick: () => R(K),
          onKeyDown: re => {
            (re.key === "Enter" || re.key === " ") && R(K);
          },
          "aria-label": `Открыть информацию: ${K.name}`,
          children: [jsxRuntime.jsxs("div", {
            className: "mc-collection-card-art",
            children: [K.thumbnailPath ? jsxRuntime.jsx("img", {
              src: `/${K.thumbnailPath}`,
              alt: K.name,
              loading: "lazy"
            }) : jsxRuntime.jsx("i", {
              children: "?"
            }), jsxRuntime.jsx("span", {})]
          }), jsxRuntime.jsx("div", {
            className: "mc-collection-card-rarity",
            children: K.rarity
          }), ue && (K.copies || 1) > 1 && jsxRuntime.jsxs("span", {
            className: "mc-collection-card-copies",
            children: ["×", K.copies]
          }), jsxRuntime.jsx("div", {
            className: "mc-collection-card-bottom",
            children: jsxRuntime.jsx("b", {
              children: K.name
            })
          })]
        }, K.id))
      }), F && jsxRuntime.jsx("button", {
        className: "mc-collection-more",
        type: "button",
        disabled: le,
        onClick: K => {
          K.currentTarget.blur(), V(re => re + 40), G.length >= p.length && h(!0);
        },
        children: le ? "Загружаем…" : "Показать ещё"
      })]
    }) : jsxRuntime.jsxs("div", {
      className: "mc-collection-mystery",
      children: [jsxRuntime.jsxs("div", {
        className: "mc-collection-grid",
        "aria-label": "Неоткрытые карты",
        children: [jsxRuntime.jsx("article", {
          className: "mc-collection-card mystery",
          children: jsxRuntime.jsx("div", {
            className: "mc-collection-card-art",
            children: jsxRuntime.jsx("i", {
              children: "?"
            })
          })
        }), jsxRuntime.jsx("article", {
          className: "mc-collection-card mystery",
          children: jsxRuntime.jsx("div", {
            className: "mc-collection-card-art",
            children: jsxRuntime.jsx("i", {
              children: "?"
            })
          })
        })]
      }), jsxRuntime.jsx("p", {
        children: se || r !== "all" ? "По этому запросу карты ещё не нашлись." : "Здесь пока ждут неоткрытые карты."
      })]
    }), M && jsxRuntime.jsxs("section", {
      className: "mc-card-modal",
      role: "dialog",
      "aria-modal": "true",
      "aria-label": `Информация о карте ${M.name}`,
      children: [jsxRuntime.jsx("button", {
        className: "mc-card-modal-backdrop",
        type: "button",
        onClick: () => R(null),
        "aria-label": "Закрыть"
      }), jsxRuntime.jsxs("article", {
        className: `mc-card-modal-sheet ${ce ? "video" : ""} ${M.rarity.toLowerCase()} ${M.owned ? "owned" : "missing"}`,
        children: [jsxRuntime.jsx("button", {
          className: "mc-card-modal-close mc-icon-button",
          type: "button",
          onClick: () => R(null),
          "aria-label": "Закрыть",
          children: jsxRuntime.jsx(IconX, { "aria-hidden": "true" })
        }), jsxRuntime.jsx("div", {
          className: "mc-card-modal-art",
          children: ce ? H ? jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [jsxRuntime.jsx("video", {
              src: `/${H}`,
              poster: M.thumbnailPath ? `/${M.thumbnailPath}` : void 0,
              autoPlay: !0,
              loop: !0,
              playsInline: !0,
              preload: "none",
              "aria-label": M.name
            }), jsxRuntime.jsx("button", {
              className: "mc-card-modal-fullscreen",
              type: "button",
              onClick: K => {
                K.stopPropagation(), vb(K.currentTarget);
              },
              "aria-label": "Открыть видео на весь экран",
              children: "⛶"
            })]
          }) : M.thumbnailPath ? jsxRuntime.jsx("img", {
            src: `/${M.thumbnailPath}`,
            alt: M.name
          }) : jsxRuntime.jsx("i", {
            children: "?"
          }) : M.thumbnailPath ? jsxRuntime.jsx("img", {
            src: `/${M.thumbnailPath}`,
            alt: M.name
          }) : jsxRuntime.jsx("i", {
            children: "?"
          })
        }), jsxRuntime.jsxs("header", {
          children: [jsxRuntime.jsx("small", {
            children: M.rarity
          }), jsxRuntime.jsx("h2", {
            children: M.name
          }), jsxRuntime.jsx("p", {
            children: Me
          })]
        }), jsxRuntime.jsxs("div", {
          className: "mc-card-modal-stats mc-card-modal-stats-with-health",
          children: [jsxRuntime.jsxs("div", {
            children: [jsxRuntime.jsx("small", {
              children: "УРОН"
            }), jsxRuntime.jsx("b", {
              children: M.damage ?? 0
            })]
          }), jsxRuntime.jsxs("div", {
            children: [jsxRuntime.jsx("small", {
              children: "ХП"
            }), jsxRuntime.jsx("b", {
              children: M.health ?? "—"
            })]
          }), jsxRuntime.jsxs("div", {
            children: [jsxRuntime.jsx("small", {
              children: "МОДИФИКАТОР"
            }), jsxRuntime.jsx("b", {
              children: M.modifier || "—"
            })]
          }), jsxRuntime.jsxs("div", {
            children: [jsxRuntime.jsx("small", {
              children: "ПОЛУЧЕНА"
            }), jsxRuntime.jsx("b", {
              children: M.acquiredAt || "—"
            })]
          })]
        }), jsxRuntime.jsx("div", {
          className: "mc-card-modal-status",
          children: jsxRuntime.jsx("span", {
            children: M.owned ? `✦ В коллекции${ue ? ` · ×${M.copies || 1}` : ""}` : "◇ Ещё не открыта"
          })
        })]
      })]
    }), P && jsxRuntime.jsxs("section", {
      className: "mc-vabank-card-settings",
      role: "dialog",
      "aria-modal": "true",
      "aria-label": "Карты для ВА-БАНК",
      children: [jsxRuntime.jsx("button", {
        className: "mc-vabank-card-settings-backdrop",
        type: "button",
        onClick: () => W(!1),
        "aria-label": "Закрыть"
      }), jsxRuntime.jsxs("article", {
        children: [jsxRuntime.jsxs("header", {
          children: [jsxRuntime.jsxs("div", {
            children: [jsxRuntime.jsx("small", {
              children: "ВА-БАНК"
            }), jsxRuntime.jsx("h2", {
              children: "Карты для ставок"
            }), jsxRuntime.jsx("p", {
              children: "Включите только те карты, которыми готовы рисковать."
            })]
          }), jsxRuntime.jsx("button", {
            className: "mc-icon-button",
            type: "button",
            onClick: () => W(!1),
            "aria-label": "Закрыть",
            children: jsxRuntime.jsx(IconX, { "aria-hidden": "true" })
          })]
        }), w ? jsxRuntime.jsx("p", {
          className: "mc-vabank-card-settings-empty",
          children: "Загружаем карты…"
        }) : ee.length ? jsxRuntime.jsx("div", {
          className: "mc-vabank-card-settings-list",
          children: ee.map(K => jsxRuntime.jsxs("button", {
            type: "button",
            className: K.enabled ? "enabled" : "",
            disabled: K.locked || ne === K.id,
            onClick: () => {
              me(K);
            },
            children: [jsxRuntime.jsxs("span", {
              children: [jsxRuntime.jsx("b", {
                children: K.name
              }), jsxRuntime.jsxs("small", {
                children: [K.rarity, " · #", K.cardNumber ?? "—", " · ", K.valueCrystals.toLocaleString("ru-RU"), " 💎"]
              })]
            }), jsxRuntime.jsx("i", {
              children: K.locked ? "В ИГРЕ" : K.enabled ? "ВКЛ" : "ВЫКЛ"
            })]
          }, K.id))
        }) : jsxRuntime.jsx("p", {
          className: "mc-vabank-card-settings-empty",
          children: "Нет LIMITED или Mystic карт."
        })]
      })]
    }), U && jsxRuntime.jsxs("section", {
      className: "mc-universe-picker",
      role: "dialog",
      "aria-modal": "true",
      "aria-label": "Выбор вселенной",
      children: [jsxRuntime.jsx("button", {
        className: "mc-universe-picker-backdrop",
        type: "button",
        onClick: () => N(!1),
        "aria-label": "Закрыть"
      }), jsxRuntime.jsxs("article", {
        children: [jsxRuntime.jsxs("header", {
          children: [jsxRuntime.jsxs("div", {
            children: [jsxRuntime.jsx("small", {
              children: "КОЛЛЕКЦИЯ"
            }), jsxRuntime.jsx("h2", {
              children: "Выберите вселенную"
            })]
          }), jsxRuntime.jsx("button", {
            className: "mc-icon-button",
            type: "button",
            onClick: () => N(!1),
            "aria-label": "Закрыть",
            children: jsxRuntime.jsx(IconX, { "aria-hidden": "true" })
          })]
        }), jsxRuntime.jsx("div", {
          className: "mc-universe-picker-list",
          children: (y?.universes || []).map(K => jsxRuntime.jsxs("button", {
            type: "button",
            className: y?.universe === K.key ? "active" : "",
            onClick: () => wt(K),
            children: [jsxRuntime.jsx("span", {
              children: K.name
            }), K.total !== null && jsxRuntime.jsxs("em", {
              children: [K.total.toLocaleString("ru-RU"), " карт"]
            })]
          }, K.key))
        })]
      })]
    })]
  });
}
